if (!customElements.get("hotspot-product")) {
  customElements.define(
    "hotspot-product",
    class HotspotProduct extends HTMLElement {
      constructor() {
        super();
        this.mainDetailsToggle = this.querySelector("details");
        this.summary = this.mainDetailsToggle.querySelector("summary");
        this.content = this.summary.nextElementSibling;

        this.summary.addEventListener("click", this.onToggle.bind(this));
        this.setContentHeight();
        this.setContentTransformations();
      }

      getTotalChildrenHeight(parent) {
        let totalHeight = 0;
        const children = parent.children;

        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          const childHeight = child.getBoundingClientRect().height;
          totalHeight += childHeight;
        }

        return totalHeight;
      }

      setContentHeight() {
        this.content.style.setProperty(
          "--content-height",
          `${this.getTotalChildrenHeight(this.content)}px`
        );
      }

      setContentTransformations() {

       //console.log(this.getTotalChildrenHeight(this.content));
       //console.log(this.parentElement.offsetHeight);
       //console.log(this.content.getBoundingClientRect().y - this.parentElement.getBoundingClientRect().y);

        const width = this.content.offsetWidth;
        const height = this.getTotalChildrenHeight(this.content);
        const parentWidth = this.parentElement.offsetWidth;
        const parentHeight = this.parentElement.offsetHeight;
        const relativeX = this.content.getBoundingClientRect().x - this.parentElement.getBoundingClientRect().x;
        const relativeY = this.content.getBoundingClientRect().y - this.parentElement.getBoundingClientRect().y;
        const markerHeight = this.summary.offsetHeight;


        const overflowingX = ( width + relativeX ) > parentWidth
        const overflowingY = ( height + relativeY) > parentHeight
        
        if( overflowingX && overflowingY ){
          this.content.classList.add('shift-xy')
        }else if(overflowingX){
          this.content.classList.add('shift-x')
        }else if(overflowingY){
          this.content.classList.add('shift-y')
        }
      }

      onToggle(event) {
        event.preventDefault();
        if (!this.mainDetailsToggle.hasAttribute("open")) {
          this.mainDetailsToggle.setAttribute("open", true);
          this.setContentHeight();
          this.setContentTransformations();
          setTimeout(() => {
            this.mainDetailsToggle.classList.add("active");
          });
        } else {
          this.setContentHeight();
          this.mainDetailsToggle.classList.remove("active");
          setTimeout(() => {
            this.mainDetailsToggle.removeAttribute("open");
          }, 250);
        }
      }
    }
  );
}
